import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

export const DeathCauseDropdown = (props) => {
  const { t } = useTranslation();
  const [causes, setCauses] = useState([]);

  useEffect(() => {
    Fetch('api/data/death_causes', 'get', null, (data) => {
      setCauses(data);
    });
  }, []);

  return (
    <select name="death_cause" value={props.selected || ''} onChange={props.onChange} style={props.style}>
      {props.showAll && <option value="">{t("all_causes")}</option>}
      {!props.showAll && <option value="">{t("select_cause")}</option>}
      {causes.map(c => (
        <option key={c._id} value={c.name}>{c.name}</option>
      ))}
    </select>
  );
}
export default DeathCauseDropdown;
